/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './portal-service-schema-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './portal-service-schema-types';
const defaultOptions = {} as const;
export type DomainEnvironmentMappingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type DomainEnvironmentMappingDataQuery = { domainEnvironmentMappings: { nodes: Array<{ portalUrl: string, portalUrls: Array<{ url: string, urlType: Types.PortalUrlType }> }> } | null };

export type CheckSubdomainAvailabilityQueryVariables = Exact<{
  input: Types.CheckSubdomainAvailableInput;
}>;


export type CheckSubdomainAvailabilityQuery = { checkSubdomainAvailability: { result: Types.SubdomainAvailableResult } | null };

export type PortalServiceConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalServiceConfigurationQuery = { domainEnvironmentMappings: { nodes: Array<{ portalSubDomain: string, environmentId: any, id: any, tenantId: any, updatedDate: any, updatedUser: string, portalUrl: string, portalUrls: Array<{ url: string, urlType: Types.PortalUrlType }> }> } | null, ipWhitelistPatterns: { edges: Array<{ node: { pattern: string, id: any } }> } | null };

export type UpdateDomainEnvironmentMappingMutationVariables = Exact<{
  input: Types.UpdateDomainEnvironmentMappingInput;
}>;


export type UpdateDomainEnvironmentMappingMutation = { updateDomainEnvironmentMapping: { domainEnvironmentMapping: { updatedUser: string, updatedDate: any, tenantId: any, portalSubDomain: string, id: any, createdUser: string, createdDate: any, environmentId: any } | null } | null };

export type CreateIpWhitelistPatternMutationVariables = Exact<{
  input: Types.CreateIpWhitelistPatternInput;
}>;


export type CreateIpWhitelistPatternMutation = { createIpWhitelistPattern: { ipWhitelistPattern: { id: any, pattern: string } | null } | null };

export type DeleteIpWhitelistPatternMutationVariables = Exact<{
  input: Types.DeleteIpWhitelistPatternInput;
}>;


export type DeleteIpWhitelistPatternMutation = { deleteIpWhitelistPattern: { ipWhitelistPattern: { id: any } | null } | null };


export const DomainEnvironmentMappingDataDocument = gql`
    query DomainEnvironmentMappingData {
  domainEnvironmentMappings {
    nodes {
      portalUrl
      portalUrls {
        url
        urlType
      }
    }
  }
}
    `;

/**
 * __useDomainEnvironmentMappingDataQuery__
 *
 * To run a query within a React component, call `useDomainEnvironmentMappingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainEnvironmentMappingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainEnvironmentMappingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDomainEnvironmentMappingDataQuery(baseOptions?: Apollo.QueryHookOptions<DomainEnvironmentMappingDataQuery, DomainEnvironmentMappingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainEnvironmentMappingDataQuery, DomainEnvironmentMappingDataQueryVariables>(DomainEnvironmentMappingDataDocument, options);
      }
export function useDomainEnvironmentMappingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainEnvironmentMappingDataQuery, DomainEnvironmentMappingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainEnvironmentMappingDataQuery, DomainEnvironmentMappingDataQueryVariables>(DomainEnvironmentMappingDataDocument, options);
        }
export type DomainEnvironmentMappingDataQueryHookResult = ReturnType<typeof useDomainEnvironmentMappingDataQuery>;
export type DomainEnvironmentMappingDataLazyQueryHookResult = ReturnType<typeof useDomainEnvironmentMappingDataLazyQuery>;
export type DomainEnvironmentMappingDataQueryResult = Apollo.QueryResult<DomainEnvironmentMappingDataQuery, DomainEnvironmentMappingDataQueryVariables>;
export const CheckSubdomainAvailabilityDocument = gql`
    query CheckSubdomainAvailability($input: CheckSubdomainAvailableInput!) {
  checkSubdomainAvailability(input: $input) {
    result
  }
}
    `;

/**
 * __useCheckSubdomainAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckSubdomainAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSubdomainAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSubdomainAvailabilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckSubdomainAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CheckSubdomainAvailabilityQuery, CheckSubdomainAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSubdomainAvailabilityQuery, CheckSubdomainAvailabilityQueryVariables>(CheckSubdomainAvailabilityDocument, options);
      }
export function useCheckSubdomainAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSubdomainAvailabilityQuery, CheckSubdomainAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSubdomainAvailabilityQuery, CheckSubdomainAvailabilityQueryVariables>(CheckSubdomainAvailabilityDocument, options);
        }
export type CheckSubdomainAvailabilityQueryHookResult = ReturnType<typeof useCheckSubdomainAvailabilityQuery>;
export type CheckSubdomainAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckSubdomainAvailabilityLazyQuery>;
export type CheckSubdomainAvailabilityQueryResult = Apollo.QueryResult<CheckSubdomainAvailabilityQuery, CheckSubdomainAvailabilityQueryVariables>;
export const PortalServiceConfigurationDocument = gql`
    query PortalServiceConfiguration {
  domainEnvironmentMappings {
    nodes {
      portalSubDomain
      environmentId
      id
      tenantId
      updatedDate
      updatedUser
      portalUrl
      portalUrls {
        url
        urlType
      }
    }
  }
  ipWhitelistPatterns {
    edges {
      node {
        pattern
        id
      }
    }
  }
}
    `;

/**
 * __usePortalServiceConfigurationQuery__
 *
 * To run a query within a React component, call `usePortalServiceConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalServiceConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalServiceConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalServiceConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<PortalServiceConfigurationQuery, PortalServiceConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalServiceConfigurationQuery, PortalServiceConfigurationQueryVariables>(PortalServiceConfigurationDocument, options);
      }
export function usePortalServiceConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalServiceConfigurationQuery, PortalServiceConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalServiceConfigurationQuery, PortalServiceConfigurationQueryVariables>(PortalServiceConfigurationDocument, options);
        }
export type PortalServiceConfigurationQueryHookResult = ReturnType<typeof usePortalServiceConfigurationQuery>;
export type PortalServiceConfigurationLazyQueryHookResult = ReturnType<typeof usePortalServiceConfigurationLazyQuery>;
export type PortalServiceConfigurationQueryResult = Apollo.QueryResult<PortalServiceConfigurationQuery, PortalServiceConfigurationQueryVariables>;
export const UpdateDomainEnvironmentMappingDocument = gql`
    mutation UpdateDomainEnvironmentMapping($input: UpdateDomainEnvironmentMappingInput!) {
  updateDomainEnvironmentMapping(input: $input) {
    domainEnvironmentMapping {
      updatedUser
      updatedDate
      tenantId
      portalSubDomain
      id
      createdUser
      createdDate
      environmentId
    }
  }
}
    `;
export type UpdateDomainEnvironmentMappingMutationFn = Apollo.MutationFunction<UpdateDomainEnvironmentMappingMutation, UpdateDomainEnvironmentMappingMutationVariables>;

/**
 * __useUpdateDomainEnvironmentMappingMutation__
 *
 * To run a mutation, you first call `useUpdateDomainEnvironmentMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainEnvironmentMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainEnvironmentMappingMutation, { data, loading, error }] = useUpdateDomainEnvironmentMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDomainEnvironmentMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDomainEnvironmentMappingMutation, UpdateDomainEnvironmentMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainEnvironmentMappingMutation, UpdateDomainEnvironmentMappingMutationVariables>(UpdateDomainEnvironmentMappingDocument, options);
      }
export type UpdateDomainEnvironmentMappingMutationHookResult = ReturnType<typeof useUpdateDomainEnvironmentMappingMutation>;
export type UpdateDomainEnvironmentMappingMutationResult = Apollo.MutationResult<UpdateDomainEnvironmentMappingMutation>;
export type UpdateDomainEnvironmentMappingMutationOptions = Apollo.BaseMutationOptions<UpdateDomainEnvironmentMappingMutation, UpdateDomainEnvironmentMappingMutationVariables>;
export const CreateIpWhitelistPatternDocument = gql`
    mutation CreateIpWhitelistPattern($input: CreateIpWhitelistPatternInput!) {
  createIpWhitelistPattern(input: $input) {
    ipWhitelistPattern {
      id
      pattern
    }
  }
}
    `;
export type CreateIpWhitelistPatternMutationFn = Apollo.MutationFunction<CreateIpWhitelistPatternMutation, CreateIpWhitelistPatternMutationVariables>;

/**
 * __useCreateIpWhitelistPatternMutation__
 *
 * To run a mutation, you first call `useCreateIpWhitelistPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIpWhitelistPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIpWhitelistPatternMutation, { data, loading, error }] = useCreateIpWhitelistPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIpWhitelistPatternMutation(baseOptions?: Apollo.MutationHookOptions<CreateIpWhitelistPatternMutation, CreateIpWhitelistPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIpWhitelistPatternMutation, CreateIpWhitelistPatternMutationVariables>(CreateIpWhitelistPatternDocument, options);
      }
export type CreateIpWhitelistPatternMutationHookResult = ReturnType<typeof useCreateIpWhitelistPatternMutation>;
export type CreateIpWhitelistPatternMutationResult = Apollo.MutationResult<CreateIpWhitelistPatternMutation>;
export type CreateIpWhitelistPatternMutationOptions = Apollo.BaseMutationOptions<CreateIpWhitelistPatternMutation, CreateIpWhitelistPatternMutationVariables>;
export const DeleteIpWhitelistPatternDocument = gql`
    mutation DeleteIpWhitelistPattern($input: DeleteIpWhitelistPatternInput!) {
  deleteIpWhitelistPattern(input: $input) {
    ipWhitelistPattern {
      id
    }
  }
}
    `;
export type DeleteIpWhitelistPatternMutationFn = Apollo.MutationFunction<DeleteIpWhitelistPatternMutation, DeleteIpWhitelistPatternMutationVariables>;

/**
 * __useDeleteIpWhitelistPatternMutation__
 *
 * To run a mutation, you first call `useDeleteIpWhitelistPatternMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIpWhitelistPatternMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIpWhitelistPatternMutation, { data, loading, error }] = useDeleteIpWhitelistPatternMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIpWhitelistPatternMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIpWhitelistPatternMutation, DeleteIpWhitelistPatternMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIpWhitelistPatternMutation, DeleteIpWhitelistPatternMutationVariables>(DeleteIpWhitelistPatternDocument, options);
      }
export type DeleteIpWhitelistPatternMutationHookResult = ReturnType<typeof useDeleteIpWhitelistPatternMutation>;
export type DeleteIpWhitelistPatternMutationResult = Apollo.MutationResult<DeleteIpWhitelistPatternMutation>;
export type DeleteIpWhitelistPatternMutationOptions = Apollo.BaseMutationOptions<DeleteIpWhitelistPatternMutation, DeleteIpWhitelistPatternMutationVariables>;